import {PATIENT_CONTEXT_ITEMS} from './components/forms/componentList';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ctxCurrentTab} from '../../../store/reducers/patientContext';
import TabPanelContext from './components/tabPanelContext';
import {hasOneOfPermission} from '../../../store/reducers/user';
import ErrorBoundary from '../../../controls/errorBoundary';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {isMobile} from 'react-device-detect';
import {getConfig} from '../../../util/configUtil';
import PatientHelper from '../../../controls/helpers/patientHelper';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    iframe: {
        width: '100%',
        height: '99%',
    },
}));

const ContextBox = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    // Props
    const {idElement, splitActive, forceTab, ...restProps} = props;

    // Selectors
    const currentTab = useSelector(ctxCurrentTab);
    const getPatientHospitalNumber = patient => {
        return patient?.patient ? PatientHelper.getPatientHospitalNumber(patient.patient) : '';
    };

    const getIframeURL = (id) => {
        switch (id) {
            case 'ucr':
            case 'ucrFiltered': {
                let url = getConfig(id === 'ucr' ? 'ucrIFrame.url' : 'ucrIFrameFilteredDocumentTypes.url');
                let patientHospitalNumber = getPatientHospitalNumber(props.patient).replace('/', '_$_');
                let token = window.auth.token;
                let refreshToken = window.auth.refreshToken;
                let timeoutOverdue = getConfig(isMobile ? 'timeout.mobileDefaultTimeout' : 'timeout.regularDefaultTimeout');
                url = url.replace('^^patient.hospitalNumber^^', patientHospitalNumber);
                url = url.replace('^^token^^', token);
                url = url.replace('^^refreshToken^^', refreshToken);
                url = url.replace('^^timeoutOverdue^^', timeoutOverdue);

                if (id === 'ucrFiltered') {
                    let docTypes = '';
                    getConfig('ucrIFrameFilteredDocumentTypes.documentTypes', []).forEach((dt) => {
                        if (docTypes.length === 0) {
                            docTypes += '' + dt;
                        } else {
                            docTypes += '|' + dt;
                        }
                    });
                    url = url.replace('^^docTypesList^^', encodeURI(docTypes));
                }
                return url;
            }

            default:
                return null;
        }
    };

    const renderContext = (item) => {
        if (item?.options?.iframe) {
            return (
                <iframe
                    className={clsx(classes.iframe, 'post-message-access')}
                    src={getIframeURL(item.id)}
                    title={item.id}
                />
            );
        }
        return (item?.context && React.cloneElement(item?.context, {...restProps})) || null;
    };

    return (
        <>
            {PATIENT_CONTEXT_ITEMS.map(item => {
                let visible = item.enabled;
                if (!_.isEmpty(item.excludePatientType)) {
                    visible = !_.some(item.excludePatientType, type => type === props.patientType);
                }
                if (!visible) return null;

                let disabled = false;
                if (!_.isEmpty(item.requiredPermission)) {
                    disabled = !dispatch(hasOneOfPermission(item.requiredPermission));
                }

                if (disabled || !visible) return null;

                return (
                    <TabPanelContext
                        key={item?.id}
                        index={item?.id}
                        idElement={idElement}
                        value={splitActive ? forceTab : currentTab}
                        hideScroll={item?.options?.hideScroll || splitActive}
                    >
                        <ErrorBoundary>
                            {renderContext(item)}
                        </ErrorBoundary>
                    </TabPanelContext>
                );
            })}
        </>
    );
};

function areEqual(prevProps, nextProps) {
    let isEqual = _.isEqual(prevProps.patient, nextProps.patient);
    isEqual = isEqual && _.isEqual(prevProps.idElement, nextProps.idElement);
    isEqual = isEqual && _.isEqual(prevProps.patientType, nextProps.patientType);
    isEqual = isEqual && _.isEqual(prevProps.patientAgeType, nextProps.patientAgeType);
    isEqual = isEqual && _.isEqual(prevProps.disableSave, nextProps.disableSave);
    isEqual = isEqual && _.isEqual(prevProps.pastAttendances, nextProps.pastAttendances);
    isEqual = isEqual && _.isEqual(prevProps.splitActive, nextProps.splitActive);
    isEqual = isEqual && _.isEqual(prevProps.forceTab, nextProps.forceTab);
    isEqual = isEqual && _.isEqual(prevProps.workflowDisabled, nextProps.workflowDisabled);
    return isEqual;
}

export default React.memo(ContextBox, areEqual);